import { render, staticRenderFns } from "./SuperAdminLogs.vue?vue&type=template&id=559fb426&lang=html"
import script from "./SuperAdminLogs.vue?vue&type=script&lang=js"
export * from "./SuperAdminLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports